import { render, staticRenderFns } from "./ActionsColumn.vue?vue&type=template&id=066e9c26&scoped=true"
import script from "./ActionsColumn.vue?vue&type=script&lang=ts"
export * from "./ActionsColumn.vue?vue&type=script&lang=ts"
import style0 from "./ActionsColumn.vue?vue&type=style&index=0&id=066e9c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e9c26",
  null
  
)

export default component.exports